// Reglas puras del correo del paso 01: formato, tipo y si deja continuar.
import type { EmailKind, WizardSession } from './types';

/** Formato mínimo antes de habilitar «Enviar código»; el silo lo valida de nuevo. */
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Tipos de correo; Personal va primero porque viene preseleccionado. */
export const EMAIL_KIND_OPTIONS: { value: EmailKind; label: string }[] = [
    { value: 'PERSONAL', label: 'Personal' },
    { value: 'CORPORATE', label: 'Corporativo' },
];

export function isEmailFormatValid(value: string): boolean {
    return EMAIL_FORMAT.test(value.trim());
}

/** `PERSONAL` → «Personal»; sin tipo, sin etiqueta. */
export function emailKindLabel(kind: EmailKind | undefined): string | undefined {
    return EMAIL_KIND_OPTIONS.find((option) => option.value === kind)?.label;
}

/** ¿El correo deja continuar? La venta que aceptó términos antes del correo no se bloquea. */
export function emailSettled(session: Pick<WizardSession, 'email' | 'consentsAccepted'>): boolean {
    if (!session.email) return session.consentsAccepted;
    return session.email.state !== 'PENDING';
}
